// extracted by mini-css-extract-plugin
export default {"root":"root--2ed3184","toggle":"toggle--9705214","switch":"switch--f9911df","slider":"slider--933d6be","checked":"checked--2533c71","submitted":"submitted--d5faae8"};